import {React, useState} from 'react'
import { useTranslate,Form,useRecordContext, useNotify } from 'react-admin'
import { Grid, Button, TextField} from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import SaveIcon from '@mui/icons-material/Save'
import LoadingButton from '@mui/lab/LoadingButton'
import { itemServices } from 'src/services/reservation/item/item.service'

export const OtherCodeEditModal = ({setOpenCodeModal, refresh}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const other = useRecordContext()
    const [isLoading, setIsLoading] = useState(false)
    const [form, setForm] = useState({
        code:other.code,
    })

    const onChangeForm = (field, value) =>{
        setForm({...form, [field]:value.target.value})
    }

    const postSave = async ()=>{
        setIsLoading(true)
        await itemServices.editOtherCodes(other.id_detail,form).finally(()=>{
            setIsLoading(false)
        }).then(()=>{
            setOpenCodeModal(false)
            refresh()
        }).catch(err=>{
            console.log("err", err)
            notify('ra.notification.edit_codes_error',{type:'error'})
        })
    }
  return (
    <div>
        <Form id='post_create_form' warnWhenUnsavedChanges onSubmit={postSave}>
            <Grid id='post_create_form' container spacing={3}>
                <EditInputsWrap md={12} label={translate(`${translate('ra.field.provider_code')}`)}  >
                    <TextField onChange={(value)=>onChangeForm('code', value)} value={form.code} size='small' fullWidth />
                </EditInputsWrap>
            </Grid>
        </Form>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
        <LoadingButton
            loading={isLoading}
            variant='contained'
            startIcon={<SaveIcon />}
            form='post_create_form'
            type='submit'
            >
            {translate('ra.action.save')}
            </LoadingButton>
            <Button onClick={()=>setOpenCodeModal(false)} variant='outlined' color='error'>
            {translate('ra.action.cancel')}
            </Button>
        </div>
    </div>
  )
}
